import SignedInHeaderSection from '../../../layout/SignedInHeaderSection';
import styles from './HeaderMainsite.module.css';

export default function HeaderMainsite({ scrolled }: { scrolled?: boolean }) {
  return (
    <header
      id="top"
      className={`header js-sticky ${scrolled ? 'sticked' : ''}`}
      data-scrollheight="0"
    >
      <div className="container-fluid" style={{ position: 'relative' }}>
        <div className={styles['signed-in']}>
          <SignedInHeaderSection showProfile={false} />
        </div>
        <div className="row align-items-center">
          <div className="col-12 text-center">
            <a
              className="logo"
              href="https://www.percihealth.com"
              title="Perci Health provides on-demand access to high-quality cancer experts who are focused on the side effects of treatment."
            >
              {/* Deliberately NOT assets/logo.svg: the mainsite header needs
                  this large/mobile logotype pair (d-md responsive swap) at
                  mainsite coordinate scales; the shared asset is the app-bar
                  mark. */}
              <svg
                className="d-none d-md-inline perci-logo"
                xmlns="http://www.w3.org/2000/svg"
                width="110.797"
                height="35.041"
                viewBox="0 0 1897.06 600"
              >
                <path
                  d="M25.17,410.81h65.84v-111.1H0l25.17,111.1ZM349.59,48.55H103.93v539.38h124.85V159.65h103.9c54.77,0,85.38,24.15,85.38,70.04s-30.61,70.04-85.38,70.04h-90.98v111.1h107.89c136.93,0,194.92-81.31,194.92-181.14s-57.97-181.14-194.92-181.14ZM1151.96,282.01h-9.68v-96.6h-121.02v402.52h121.02v-182.74c0-65.21,30.66-107.07,82.3-107.07h64.54v-112.71h-41.15c-47.6,0-87.14,29.79-96.01,96.6ZM770.04,173.33c-125.06,0-208.16,85.33-208.16,213.34,0,135.25,75.04,213.34,205.74,213.34,102.47,0,182.34-48.3,200.09-142.49h-117.8c-9.68,26.57-37.92,44.28-79.87,44.28-52.44,0-80.68-31.4-87.14-84.53h289.65c12.91-141.69-71-243.93-202.51-243.93ZM684.51,348.02c4.03-45.89,31.47-78.89,83.1-78.89s80.68,33.01,83.1,78.89h-166.2ZM1767.04,185.4v402.52h121.02V185.4h-121.02ZM1516.95,277.18c45.18,0,71.81,25.76,80.68,63.6h119.41c-8.07-97.41-81.49-167.45-200.09-167.45-129.09,0-208.16,82.92-208.16,213.34s79.07,213.34,208.16,213.34c108.92,0,190.41-70.84,198.48-170.67h-117.8c-6.45,33.01-33.08,66.82-79.87,66.82-54.86,0-86.33-46.69-86.33-109.49s30.66-109.49,85.52-109.49Z"
                  fill="#164a38"
                ></path>
                <path
                  d="M1826.74,0c-38.83,0-70.32,31.41-70.32,70.16s31.48,70.16,70.32,70.16,70.32-31.41,70.32-70.16S1865.58,0,1826.74,0Z"
                  fill="#5f908e"
                ></path>
              </svg>
              <svg
                className="d-md-none"
                xmlns="http://www.w3.org/2000/svg"
                width="31.229"
                height="34.379"
                viewBox="0 0 545 600"
              >
                <path
                  d="M25.17,410.81h65.84v-111.1H0l25.17,111.1ZM349.59,48.55H103.93v539.38h124.85V159.65h103.9c54.77,0,85.38,24.15,85.38,70.04s-30.61,70.04-85.38,70.04h-90.98v111.1h107.89c136.93,0,194.92-81.31,194.92-181.14s-57.97-181.14-194.92-181.14Z"
                  fill="#164a38"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
